export default {
  "root": "_root_dkn40_1",
  "decorator": "_decorator_dkn40_1",
  "field": "_field_dkn40_1",
  "--size-small": "_--size-small_dkn40_1",
  "--size-medium": "_--size-medium_dkn40_1",
  "--size-large": "_--size-large_dkn40_1",
  "icon": "_icon_dkn40_1",
  "input": "_input_dkn40_1",
  "--error": "_--error_dkn40_1",
  "--disabled": "_--disabled_dkn40_1",
  "--size-small--m": "_--size-small--m_dkn40_1",
  "--size-medium--m": "_--size-medium--m_dkn40_1",
  "--size-large--m": "_--size-large--m_dkn40_1",
  "--size-small--l": "_--size-small--l_dkn40_1",
  "--size-medium--l": "_--size-medium--l_dkn40_1",
  "--size-large--l": "_--size-large--l_dkn40_1",
  "--size-small--xl": "_--size-small--xl_dkn40_1",
  "--size-medium--xl": "_--size-medium--xl_dkn40_1",
  "--size-large--xl": "_--size-large--xl_dkn40_1"
};import "ni:sha-256;gHcVD3aZrECAOoGMOrxsLwVubPlwAxR6djG6cv70ybw";